module.exports = __webpack_public_path__ + "static/media/cabinet.929bfc6a.svg";